import { render, staticRenderFns } from "./EditClient.vue?vue&type=template&id=3b478bf8&scoped=true&"
import script from "./EditClient.vue?vue&type=script&lang=js&"
export * from "./EditClient.vue?vue&type=script&lang=js&"
import style0 from "./EditClient.vue?vue&type=style&index=0&id=3b478bf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b478bf8",
  null
  
)

export default component.exports